export default __webpack_public_path__ + "static/media/wellness-rewards-logo.704b112c.png";